var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30.554 30.554",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10043",
    "data-name": "Group 10043",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M29.278,11.158A3.908,3.908,0,0,0,25.369,7.25H11.158A3.908,3.908,0,0,0,7.25,11.158V25.369a3.908,3.908,0,0,0,3.908,3.908H25.369a3.908,3.908,0,0,0,3.908-3.908Zm-2.132,0V25.369a1.777,1.777,0,0,1-1.776,1.776H11.158a1.777,1.777,0,0,1-1.776-1.776V11.158a1.777,1.777,0,0,1,1.776-1.776H25.369A1.777,1.777,0,0,1,27.146,11.158Z",
    transform: "translate(1.277 1.277)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M8.356,23.278V13.685a5.329,5.329,0,0,1,5.329-5.329h9.593v-3.2A3.908,3.908,0,0,0,19.369,1.25H5.158A3.908,3.908,0,0,0,1.25,5.158V19.369a3.908,3.908,0,0,0,3.908,3.908Z",
    transform: "translate(-1.25 -1.25)",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBackground);
export default __webpack_public_path__ + "static/media/i-background.d20b936cb7cbd0c5bf9f8ce630868cea.svg";
export { ForwardRef as ReactComponent };